import { List, Map, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { MANAGEMENT_UI } from 'constants/appRouting'
import Psfs from 'lib/psfs/Psfs'
import {
  FILTER_TYPE_ASSIGNED_USER,
  FILTER_TYPE_ASSIGNED_USER_GROUP,
  FILTER_TYPE_CREATED_BY,
  FILTER_TYPE_SITE,
  NOT_STARTED,
  ASSIGNMENTS,
  REPEAT,
  REGULAR_REPEAT_SCHEDULE,
  START_TIME,
  NEVER,
  FIELD_DUE_DATE,
  FIELD_START_DATE,
  FIELD_DUE_DATE_DATE,
  FIELD_DUE_DATE_TIME,
  WORKFLOW,
  FIELD_SITE,
} from 'constants/managementUI'
import { getUniqueTasksAssignees } from 'helpers/managementUI'

// constants
export const CLEAR_STORE = 'managementUI/CLEAR_STORE'
export const SET_PSFS = 'managementUI/SET_PSFS'
export const SET_SELECTED_OTHER_FILTERS =
  'managementUI/SET_SELECTED_OTHER_FILTERS'
export const SET_MANAGEMENT_UI_IS_LOADING =
  'managementUI/SET_MANAGEMENT_UI_IS_LOADING'
export const SET_MANAGEMENT_UI_IS_UPDATING =
  'managementUI/SET_MANAGEMENT_UI_IS_UPDATING'
export const FETCH_MANAGEMENT_UI_DATA = 'managementUI/FETCH_MANAGEMENT_UI_DATA'
export const SUCCESS_MANAGEMENT_UI_DATA =
  'managementUI/SUCCESS_MANAGEMENT_UI_DATA'
export const FAILURE_MANAGEMENT_UI_DATA =
  'managementUI/FAILURE_MANAGEMENT_UI_DATA'
export const FETCH_MANAGEMENT_UI_FILTERS =
  'managementUI/FETCH_MANAGEMENT_UI_FILTERS'
export const SUCCESS_MANAGEMENT_UI_FILTERS =
  'managementUI/SUCCESS_MANAGEMENT_UI_FILTERS'
export const FAILURE_MANAGEMENT_UI_FILTERS =
  'managementUI/FAILURE_MANAGEMENT_UI_FILTERS'
export const UPDATE_MANAGEMENT_UI_TASK_ASSIGNEES =
  'managementUI/UPDATE_MANAGEMENT_UI_TASK_ASSIGNEES'
export const UPDATE_MANAGEMENT_UI_JOB_ASSIGNEES =
  'managementUI/UPDATE_MANAGEMENT_UI_JOB_ASSIGNEES'
export const DELETE_MANAGEMENT_UI_JOB = 'managementUI/DELETE_MANAGEMENT_UI_JOB'
export const DELETE_MANAGEMENT_UI_TASK =
  'managementUI/DELETE_MANAGEMENT_UI_TASK'
export const UPDATE_MANAGEMENT_UI_TASK =
  'managementUI/UPDATE_MANAGEMENT_UI_TASK'
export const SUCCESS_MANAGEMENT_UI_TASK_ASSIGNEES =
  'managementUI/SUCCESS_MANAGEMENT_UI_TASK_ASSIGNEES'
export const SUCCESS_MANAGEMENT_UI_JOB_ASSIGNEES =
  'managementUI/SUCCESS_MANAGEMENT_UI_JOB_ASSIGNEES'
export const SUCCESS_DELETE_MANAGEMENT_UI_JOB =
  'managementUI/SUCCESS_DELETE_MANAGEMENT_UI_JOB'
export const SUCCESS_DELETE_MANAGEMENT_UI_TASK =
  'managementUI/SUCCESS_DELETE_MANAGEMENT_UI_TASK'
export const SUCCESS_MANAGEMENT_UI_TASK =
  'managementUI/SUCCESS_MANAGEMENT_UI_TASK'
export const CLEAR_DATA = 'managementUI/CLEAR_DATA'
export const SET_FORM_DATA = 'managementUI/SET_FORM_DATA'
export const CREATE_MANAGEMENT_UI_JOB = 'managementUI/CREATE_MANAGEMENT_UI_JOB'
export const SET_PLAN_NEW_JOB_IS_SAVING =
  'managementUI/SET_PLAN_NEW_JOB_IS_SAVING'

export const RESTORE_JOB = 'myJobs/RESTORE_JOB'
export const [RESTORE_JOB_SUCCESS, RESTORE_JOB_FAILURE] = [
  `${RESTORE_JOB}_SUCCESS`,
  `${RESTORE_JOB}_FAILURE`,
]

export const RESTORE_JOB_SERIES = 'myJobs/RESTORE_JOB_SERIES'
export const [RESTORE_JOB_SERIES_SUCCESS, RESTORE_JOB_SERIES_FAILURE] = [
  `${RESTORE_JOB_SERIES}_SUCCESS`,
  `${RESTORE_JOB_SERIES}_FAILURE`,
]

// actions
export const setPsfs = ActionHelper.createActionObj(SET_PSFS)
export const setSelectedOtherFilters = ActionHelper.createActionObj(
  SET_SELECTED_OTHER_FILTERS,
)
export const clearManagementUIStore = ActionHelper.createActionObj(CLEAR_STORE)
export const setIsLoading = ActionHelper.createActionObj(
  SET_MANAGEMENT_UI_IS_LOADING,
)
export const setIsUpdating = ActionHelper.createActionObj(
  SET_MANAGEMENT_UI_IS_UPDATING,
)
export const fetchManagementUIData = ActionHelper.createActionObj(
  FETCH_MANAGEMENT_UI_DATA,
)
export const fetchManagementUIFilters = ActionHelper.createActionObj(
  FETCH_MANAGEMENT_UI_FILTERS,
)
export const updateTaskAssignees = ActionHelper.createActionObj(
  UPDATE_MANAGEMENT_UI_TASK_ASSIGNEES,
)
export const deleteJob = ActionHelper.createActionObj(DELETE_MANAGEMENT_UI_JOB)
export const deleteTask = ActionHelper.createActionObj(
  DELETE_MANAGEMENT_UI_TASK,
)
export const updateTask = ActionHelper.createActionObj(
  UPDATE_MANAGEMENT_UI_TASK,
)
export const updateJobAssignees = ActionHelper.createActionObj(
  UPDATE_MANAGEMENT_UI_JOB_ASSIGNEES,
)

export const setFormData = ActionHelper.createActionObj(SET_FORM_DATA)
export const createJob = ActionHelper.createActionObj(CREATE_MANAGEMENT_UI_JOB)
export const clearData = ActionHelper.createActionObj(CLEAR_DATA)

export const restoreJob = ActionHelper.createActionObj(RESTORE_JOB)
export const restoreJobSeries = ActionHelper.createActionObj(RESTORE_JOB_SERIES)

// store
const defaultFiltersList = Map({
  [FILTER_TYPE_SITE]: [],
  [FILTER_TYPE_ASSIGNED_USER]: [],
  [FILTER_TYPE_ASSIGNED_USER_GROUP]: [],
  [FILTER_TYPE_CREATED_BY]: [],
})

export const DEFAULT_FORM_DATA = {
  [WORKFLOW]: null,
  [FIELD_SITE]: [],
  [START_TIME]: null,
  [FIELD_DUE_DATE]: NEVER,
  [REPEAT]: NEVER,
  [ASSIGNMENTS]: [],
  [FIELD_START_DATE]: null,
  [FIELD_DUE_DATE]: NEVER,
  [FIELD_DUE_DATE_DATE]: null,
  [FIELD_DUE_DATE_TIME]: null,
  [REGULAR_REPEAT_SCHEDULE]: {},
}

const initialState = () =>
  fromJS({
    formData: Map(DEFAULT_FORM_DATA),
    jobsData: List([]),
    filtersList: defaultFiltersList,
    selectedOtherFilters: List([]),
    isLoadingData: true,
    isUpdatingData: false,
    storePsfs: new Psfs(MANAGEMENT_UI),
    sortColumn: 'state',
    sortDirection: false,
    count: 0,
    isPlanNewJobSaving: false,
  })

const ManagementUI = handleActions(
  {
    [CLEAR_STORE]: () => initialState(),
    [SET_PSFS]: (state, action) => state.set('storePsfs', action.payload),
    [SET_SELECTED_OTHER_FILTERS]: (state, action) =>
      state.set('selectedOtherFilters', List(action.payload)),
    [SET_MANAGEMENT_UI_IS_LOADING]: (state, action) =>
      state.set('isLoadingData', Boolean(action.payload)),
    [SET_PLAN_NEW_JOB_IS_SAVING]: (state, action) =>
      state.set('isPlanNewJobSaving', Boolean(action.payload)),
    [SUCCESS_MANAGEMENT_UI_DATA]: (state, action) =>
      state
        .set(
          'jobsData',
          List(action.payload.data?.map(listItem => ({ ...listItem }))),
        )
        .set('count', action.payload.count),
    [FAILURE_MANAGEMENT_UI_DATA]: state => state.set('jobsData', List([])),
    [SUCCESS_MANAGEMENT_UI_FILTERS]: (state, action) =>
      state.set('filtersList', Map(action.payload)),
    [FAILURE_MANAGEMENT_UI_FILTERS]: state =>
      state.set('filtersList', defaultFiltersList),
    [SET_MANAGEMENT_UI_IS_UPDATING]: (state, action) =>
      state.set('isUpdatingData', Boolean(action.payload)),
    [SUCCESS_MANAGEMENT_UI_TASK_ASSIGNEES]: (state, action) => {
      const { jobsData } = state.toJS()
      const {
        data: { assigned_users, assigned_user_groups },
        params: { jobId, taskId },
      } = action.payload
      const jobMatch = jobsData.find(({ id }) => id === jobId)
      const taskMatch = jobMatch.tasks.find(({ id }) => id === taskId)

      taskMatch.assigned_users = assigned_users
      taskMatch.assigned_user_groups = assigned_user_groups

      const {
        assigned_users: uniqueUsers,
        assigned_user_groups: uniqueGroups,
      } = getUniqueTasksAssignees(jobMatch)

      jobMatch.assigned_users = uniqueUsers
      jobMatch.assigned_user_groups = uniqueGroups

      return state.set('jobsData', List(jobsData))
    },
    [SUCCESS_MANAGEMENT_UI_JOB_ASSIGNEES]: (state, action) => {
      const { jobsData } = state.toJS()
      const {
        data,
        params: { jobId },
      } = action.payload
      const jobMatch = jobsData.find(({ id }) => id === jobId)

      const addAssignees = (assigneeType, assigneeTypeKey) => {
        data.add[assigneeType].forEach(item => {
          const { id: addItemId } = item
          const itemMatch = jobMatch[assigneeTypeKey].find(
            ({ id: itemId }) => itemId === addItemId,
          )

          if (!itemMatch) {
            jobMatch[assigneeTypeKey].push(item)
          }

          jobMatch.tasks.forEach((task, index) => {
            const taskItemMatch = task[assigneeTypeKey].find(
              ({ id: taskItemId }) => taskItemId === addItemId,
            )

            if (!taskItemMatch) {
              jobMatch.tasks[index][assigneeTypeKey].push(item)
            }
          })
        })
      }
      const removeAssignees = (assigneeType, assigneeTypeKey) => {
        data.remove[assigneeType].forEach(item => {
          const { id: removeItemId } = item

          jobMatch[assigneeTypeKey] = jobMatch[assigneeTypeKey].filter(
            ({ id: itemId }) => removeItemId !== itemId,
          )

          jobMatch.tasks.forEach((task, index) => {
            jobMatch.tasks[index][assigneeTypeKey] = task[
              assigneeTypeKey
            ].filter(({ id: itemId }) => removeItemId !== itemId)
          })
        })
      }

      removeAssignees('users', 'assigned_users')
      removeAssignees('user_groups', 'assigned_user_groups')
      addAssignees('users', 'assigned_users')
      addAssignees('user_groups', 'assigned_user_groups')

      return state.set('jobsData', List(jobsData))
    },
    [SUCCESS_DELETE_MANAGEMENT_UI_JOB]: (state, action) => {
      const { jobsData } = state.toJS()
      const { id: jobId, job_series_id } = action.payload
      let newJobsData = [...jobsData]

      if (job_series_id) {
        newJobsData = newJobsData.filter(
          ({ job_series_id: jobSeriesId }) => jobSeriesId !== job_series_id,
        )
      } else {
        newJobsData = newJobsData.filter(({ id }) => jobId !== id)
      }

      return state.set('jobsData', List(newJobsData))
    },
    [RESTORE_JOB_SUCCESS]: (state, action) => {
      const { jobsData } = state.toJS()
      const { id: jobId } = action.payload
      const newJobsData = jobsData.filter(({ id }) => jobId !== id)

      return state.set('jobsData', List(newJobsData))
    },
    [RESTORE_JOB_SERIES_SUCCESS]: (state, action) => {
      const { jobsData } = state.toJS()
      const { job_series_id } = action.payload
      const newJobsData = jobsData.filter(
        ({ job_series_id: jobSeriesId }) => jobSeriesId !== job_series_id,
      )

      return state.set('jobsData', List(newJobsData))
    },
    [SUCCESS_MANAGEMENT_UI_TASK]: (state, action) => {
      const { jobsData } = state.toJS()
      const {
        newTaskId,
        task,
        params: { jobId },
      } = action.payload
      const jobMatch = jobsData.find(({ id }) => id === jobId)
      const newTask = {
        ...task,
        id: newTaskId,
        original_task_id: task.original_task_id || task.id,
        state: NOT_STARTED,
        duplicated: true,
        media: 0,
      }
      const newTasksList = [...jobMatch.tasks]

      newTasksList.push(newTask)
      newTasksList.sort((a, b) => {
        if (a.position === b.position) {
          return a.id - b.id
        }

        return a.position > b.position ? 1 : -1
      })
      jobMatch.tasks = newTasksList

      return state.set('jobsData', List(jobsData))
    },
    [SUCCESS_DELETE_MANAGEMENT_UI_TASK]: (state, action) => {
      const { jobsData } = state.toJS()
      const {
        id: taskId,
        params: { jobId },
      } = action.payload
      const jobMatch = jobsData.find(({ id }) => id === jobId)
      jobMatch.tasks = jobMatch.tasks.filter(({ id }) => id !== taskId)

      return state.set('jobsData', List(jobsData))
    },
    [SET_FORM_DATA]: (state, action) => {
      const { dueDateTime, startTime } = action.payload
      const formData = {
        ...action.payload,
      }

      if (startTime && typeof startTime === 'string') {
        formData.startTime = new Date().setHours(...startTime.split(':'))
      }

      if (dueDateTime) {
        if (typeof dueDateTime === 'string') {
          const splittedTime = dueDateTime.split(':')

          formData.dueDateTime = new Date().setHours(...splittedTime)
        } else {
          formData.dueDateTime = new Date(dueDateTime)
        }
      }

      return state.set('formData', Map(formData))
    },
    [CLEAR_DATA]: state => state.set('jobsData', List([])),
  },
  initialState(),
)

export default ManagementUI
